module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/json/stringify.js
// module id = /xtf
// module chunks = 0